import { Typography } from "@mui/material";

function formatTime(date: Date)
{
    let hours: number = date.getHours();
    let minutes: number = date.getMinutes();
    let ampm: string = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesStr = minutes.toString().padStart(2, '0');

    return hours + ':' + minutesStr + ' ' + ampm;
}

function datesMatch(a: Date, b: Date): boolean
{
    return a.getDate() === b.getDate() &&
        a.getMonth() === b.getMonth() &&
        a.getFullYear() === b.getFullYear();
}

function formatTimeStamp(timestamp: number)
{
    const date = new Date(timestamp);

    const today = new Date();
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);

    const time = formatTime(date);

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    if (datesMatch(date, today))
    {
        return `${time} Today`
    }
    else if (datesMatch(date, yesterday))
    {
        return `${time} Yesterday`
    }
    else
    {
        const month = monthNames[date.getMonth()];
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${time} ${month} ${day} ${year}`;
    }
}

interface Props
{
    value: number
}

export default function Timestamp({ value }: Props)
{
    return <Typography variant="body2" color="text.secondary">{formatTimeStamp(value)}</Typography>
}